import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, field, StringDecoder } from "@simonbackx/simple-encoding";
import { v4 as uuidv4 } from "uuid";
export class UserPermissions extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.isAdmin = false;
    }
}
__decorate([
    field({ decoder: BooleanDecoder })
], UserPermissions.prototype, "isAdmin", void 0);
export class User extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.firstName = "";
        this.lastName = "";
        this.permissions = null;
        this.setPassword = null;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], User.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], User.prototype, "firstName", void 0);
__decorate([
    field({ decoder: StringDecoder })
], User.prototype, "lastName", void 0);
__decorate([
    field({ decoder: StringDecoder })
], User.prototype, "email", void 0);
__decorate([
    field({ decoder: UserPermissions, nullable: true })
], User.prototype, "permissions", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, optional: true })
], User.prototype, "setPassword", void 0);
//# sourceMappingURL=User.js.map